import React from 'react';
import { Box } from '@mui/material';
import { useThemeMode } from '../../../../../contexts/ThemeProvider';

const AnimatedLogo = ({ config }: { config: any }) => {
  const { mode } = useThemeMode();
  const isDark = mode === 'dark';
  const loginConfig = config?.login || {};

  return (
    <Box
      sx={{
        width: 330,
        height: 150,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 7,
        mx: 'auto',
        position: 'relative'
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'fadeIn 0.6s ease-in-out',
          '@keyframes fadeIn': {
            '0%': { opacity: 0 },
            '100%': { opacity: 1 }
          }
        }}
      >
        <Box
          component="img"
          src={loginConfig.logo || config?.theme?.logo}
          alt={`${config?.name || 'University'} Logo`}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            position: 'relative',
            zIndex: 2,
            filter: isDark ? 'brightness(1.1) contrast(1.1)' : 'none'
          }}
          loading="lazy"
        />

      </Box>
    </Box>
  );
};

export default AnimatedLogo;
